import React from 'react';
import { AiOutlineCheck, AiOutlineClose } from 'react-icons/ai';
import { cx } from './hooks';

/**
 * items: [{ title, description, icon, status }]
 * status per item overrides the automatic one: 'finish' | 'process' | 'wait' | 'error'
 * status on the component applies to the current step (e.g. 'error').
 */
const Steps = ({ items = [], current = 0, status, size, direction, className }) => (
  <ol
    className={cx(
      'steps-bar',
      size === 'small' && 'steps-bar-sm',
      direction === 'vertical' && 'steps-bar-vertical',
      className
    )}
  >
    {items.map((item, index) => {
      let state = index < current ? 'finish' : index === current ? status || 'process' : 'wait';
      if (item.status) state = item.status;

      const stateClass = {
        finish: 'is-done',
        process: 'is-active',
        error: 'is-error',
      }[state];

      let icon = index + 1;
      if (item.icon) icon = item.icon;
      else if (state === 'finish') icon = <AiOutlineCheck />;
      else if (state === 'error') icon = <AiOutlineClose />;

      return (
        <li
          key={item.key ?? index}
          className={cx('steps-bar-item', stateClass)}
          aria-current={state === 'process' ? 'step' : undefined}
        >
          <span className={cx('steps-bar-icon', item.icon && 'is-custom')}>{icon}</span>
          <div className="steps-bar-content">
            <div className="steps-bar-title">{item.title}</div>
            {item.description && <div className="steps-bar-desc">{item.description}</div>}
          </div>
        </li>
      );
    })}
  </ol>
);

export default Steps;
